var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress progress-striped"},[_c('div',{class:_vm.classStyle,style:(`width: ${_vm.widthValue}%; background-color: ${
      _vm.isProjectCancelled ? _vm.customColor : ''
    };`),attrs:{"data-transitiongoal":_vm.value,"aria-valuenow":_vm.value,"role":"progressbar"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }